import { PAGE_ITEMS } from '../../constants';
import { IDiningMenu } from '../../types/menus.types';
import instance from './axios';

export type DiningMenuProps = {
  search?: string;
  page?: number;
  limit?: number;
};

const ENDPOINTS = {
  DINING_MENUS: '/dining-menus',
};

const getDiningMenus = ({
  limit = 20,
  page = 1,
  ...props
}: DiningMenuProps) => {
  return instance.get<{
    total: number;
    last_page: number;
    dining_menus: IDiningMenu[];
  }>(ENDPOINTS.DINING_MENUS, {
    params: {
      limit,
      page,
      ...props,
    },
  });
};

const MenusApi = {
  getDiningMenus,
};

export default MenusApi;
